import { apiUrl, credentialsMode, getToken } from "@/lib/net";

export function getAuthToken(): string | null {
  return getToken();
}

export function setAuthHeaders(headers: Record<string, string> = {}): Record<string, string> {
  const token = getAuthToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export function makeAuthenticatedRequest(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getAuthToken();
  
  // Debug logging for invoice reminder calls
  if (url.includes('remind-')) {
    console.log('🔍 makeAuthenticatedRequest debug:', {
      url,
      method: options.method,
      hasToken: !!token,
      tokenLength: token?.length || 0
    });
  }
  
  const headers: Record<string, string> = {
    ...options.headers,
    ...(token && { Authorization: `Bearer ${token}` }),
  };

  // Only add Content-Type for non-FormData bodies
  if (options.body && !(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  return fetch(apiUrl(url), {
    ...options,
    headers,
    credentials: credentialsMode(),
  });
}
